/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Scene_Descriptions_JobInputs */

const en_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Shot Descriptions Job`)
};

const fr_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descriptions des prises de vue automatiques`)
};

const de_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Schussbeschreibungen Job`)
};

const it_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro di descrizione automatica delle inquadrature`)
};

const ru_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое описание выстрелов.`)
};

const es_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción automática de tomas`)
};

const zh_cn2_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动拍摄描述工作`)
};

const ja_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動撮影の説明 仕事`)
};

const hi_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित शॉट विवरण कार्य`)
};

const pt_pt2_automatic_scene_descriptions_job = /** @type {(inputs: Automatic_Scene_Descriptions_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição automática de tarefas`)
};

/**
* | output |
* | --- |
* | "Automatic Shot Descriptions Job" |
*
* @param {Automatic_Scene_Descriptions_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_scene_descriptions_job = /** @type {((inputs?: Automatic_Scene_Descriptions_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Scene_Descriptions_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_scene_descriptions_job(inputs)
	if (locale === "de") return de_automatic_scene_descriptions_job(inputs)
	if (locale === "it") return it_automatic_scene_descriptions_job(inputs)
	if (locale === "ru") return ru_automatic_scene_descriptions_job(inputs)
	if (locale === "es") return es_automatic_scene_descriptions_job(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_scene_descriptions_job(inputs)
	if (locale === "ja") return ja_automatic_scene_descriptions_job(inputs)
	if (locale === "hi") return hi_automatic_scene_descriptions_job(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_scene_descriptions_job(inputs)
	return en_automatic_scene_descriptions_job(inputs)
});